'use strict';

import React, { Component } from 'react';
import uniqid from 'uniqid';
import Layout from 'Layouts/Front';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import Image from 'Pure/Image';
import Slider from 'Components/Slider';
import Breadcrumb from 'Components/Front/Breadcrumb';
import variant from 'Functions/variant';
import bemit from 'Functions/bemit';
import { URL, action } from 'Shared/Routes';
const {
  app,
  moment
} = window;
export default class NewsPage extends Component {
  state = {
    loading: true
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchNews();
  }
  fetchNews = () => {
    const component = this,
      props = this.props,
      state = this.state;
    qwest.post(action('getAllNews'), {
      url: document.location.pathname.slice(document.location.pathname.lastIndexOf('/') + 1),
      front: true,
      scope: 'all',
      show_past: true,
      type: 'news'
    }).then(function (xhr, response) {
      const news = response.data[0] || {};
      component.setState({
        ...news,
        slider_imgs: (news.images || []).map(function (image) {
          let data = {
            alt: image.title,
            src: variant({
              img: image,
              size: 1200
            }),
            id: uniqid()
          };
          return data;
        }),
        loading: false
      });
      app.emit({
        event: 'TCPageView',
        source: 'FrontSpacePage',
        data: {
          template: news.title,
          page: news.title
        }
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const breadcrumb = [{
      name: 'home',
      url: URL('HomePage'),
      label: 'Accueil'
    }, {
      name: 'allnews',
      url: URL('AllNewsPage'),
      label: 'Actualités'
    }, {
      name: 'current-page',
      label: state?.title,
      url: '/actualites/' + state?.url
    }];
    let output = /*#__PURE__*/React.createElement(Layout, props, /*#__PURE__*/React.createElement("div", {
      className: bemit('c-front-page-intro', ['static-page'])
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__bg"
    }), /*#__PURE__*/React.createElement("div", {
      className: "c-front-page-intro__content"
    }, /*#__PURE__*/React.createElement("header", {
      className: "c-front-page-intro__left"
    }, /*#__PURE__*/React.createElement("h1", {
      className: "c-front-page-intro__title"
    }, state.title)))), /*#__PURE__*/React.createElement("article", {
      className: "front-internal-page front-internal-page--news"
    }, /*#__PURE__*/React.createElement(Breadcrumb, {
      bemit: ['no-padding'],
      links: breadcrumb,
      className: state?.slider_imgs?.length ? 'u-margin-bottom-20' : undefined
    }), state?.slider_imgs?.length > 1 ? /*#__PURE__*/React.createElement(Slider, {
      "hide-progress": true,
      images: state.slider_imgs,
      bemit: ['news', 'cover'],
      "with-zoom": false,
      "custom-captions": true
    }) : state?.slider_imgs?.length === 1 ? /*#__PURE__*/React.createElement(Image, {
      src: state.images?.[0]?.url,
      alt: state.images?.[0]?.title,
      className: "c-news__image"
    }) : undefined, state.date ? /*#__PURE__*/React.createElement("time", {
      className: "c-title c-title--sub u-margin-top-20"
    }, moment(state.date).format('dddd DD MMMM YYYY').slice(0, 1).toUpperCase(), moment(state.date).format('dddd DD MMMM YYYY').slice(1)) : undefined, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: state?.content
      }
    })));
    return output;
  }
}
